import React from 'react'
import { observer } from 'mobx-react'
import {
  DateCell,
  TableCell,
  TableRow,
  TextCell,
} from 'components/Table/ClickableTable'
import {
  ColumnDensity,
  ColumnId,
  formattedProgressionStep,
} from 'jobs/infra/JobsTableColumns'
import SearchableJob from 'jobs/SearchableJob'
import Icon from 'components/Icon'
import FirmDashboardJobsViewModel from '../../FirmDashboardJobsViewer/FirmDashboardJobTableViewModel'
import {
  PrimaryCell,
  StatusCell,
} from 'jobs/views/JobManagement/JobsTable/JobsTableRow'

interface FirmDashboardJobsTableRowProps {
  vm: FirmDashboardJobsViewModel
  job: SearchableJob
}

export default observer(function FirmDashboardJobsTableRow({
  vm,
  job,
}: FirmDashboardJobsTableRowProps) {
  const columns = vm.columnManager.filteredColumns

  return (
    <TableRow to={vm.getJobLink(job)} data-test={'job-list-item-' + job.name}>
      {columns
        .filter((col) => col.visible)
        .map((col) => {
          switch (col.id) {
            case ColumnId.JobTitle:
              return (
                <PrimaryCell
                  job={job}
                  openTicket={vm.getLatestOpenTicketForJob(job)}
                  density={ColumnDensity.Default}
                  dataTest={`job-title-${job.id}`}
                  key={col.id}
                />
              )
            case ColumnId.JobShortId:
              return (
                <TextCell dataTest={`job-short-id-${job.id}`} key={col.id}>
                  {job.shortId}
                </TextCell>
              )
            case ColumnId.Status:
              return (
                <StatusCell
                  resolution={job.resolution}
                  status={job.status}
                  dataTest={`job-status-${job.id}`}
                  key={col.id}
                />
              )
            case ColumnId.ProgressionStep:
              return (
                <TextCell
                  dataTest={`job-progression-step-${job.id}`}
                  key={col.id}
                >
                  {formattedProgressionStep(job)}
                </TextCell>
              )
            case ColumnId.ClientTeam:
              return (
                <TextCell dataTest={`job-client-team-${job.id}`} key={col.id}>
                  {job.clientTeamName}
                </TextCell>
              )
            case ColumnId.Submitted:
              return (
                <DateCell
                  date={job.dateSubmitted}
                  density={ColumnDensity.Comfortable}
                  dataTest={`job-submitted-date-${job.id}`}
                  key={col.id}
                />
              )
            case ColumnId.Action:
              return <ArrowCell key={col.id} />
            default:
              return <TableCell key={col.id} />
          }
        })}
    </TableRow>
  )
})

const ArrowCell = () => {
  return (
    <TableCell>
      <Icon name="arrow" size={24} />
    </TableCell>
  )
}
